<template>
  <layout>
    <page-header :header="$t('coupons.create_coupon')" />
    <div class="content">
      <resource-form @saved="returnBack" @cancelled="returnBack" />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'coupons'

export default {
  name: 'CouponsCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
